import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { acceptInvitation, getInviteDetail } from "../../api/invite/memberServices";
import { UserInvite } from "../../models/UserInvite";
import { useAuth } from "../../context/AuthContext";
import LoadingPopup from "../channels/create/LoadingPopup";
import { Link } from "react-router-dom";
import { ShowChannelDetail } from "../channels/create/Preview";
import { getChannel, getChannlesByIds } from "../../api/channels/channelServices";
import { MemberInvite } from "../../models/ChannelMember";
import { collection } from "firebase/firestore";
import { SKChannel } from "../../models/SKChannel";
import { channel } from "diagnostics_channel";

const InviteList = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [selectedInviteId, setSelectedInviteId] = useState<string | undefined>(undefined);
  const [channels, setChannels] = useState<SKChannel[] | undefined>(undefined);
  const authContext = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const getChannels = async (ids: string[]) => {
      setLoading(true);
      const chanls = await getChannlesByIds(ids);
      setChannels(chanls);
      setLoading(false);
    };
    const ids = authContext?.myInvites?.map(item => item.channelId).filter((channelid): channelid is string => channelid !== undefined);

    if (ids && ids.length > 0) {
      getChannels(ids);
    }
  }, [authContext]);

  const onSelect = async (invitationId: string) => {
    const invite = authContext?.myInvites?.filter(item => item.id === invitationId)[0];
    setLoading(true);
    try {
      await acceptInvitation(invitationId);
      // if (invite?.channelId) {
      //   await acceptChannelInvitationAndJoin(invitationId, invite.channelId);
      // } else {
      //   await acceptSkarvoOperatorInvitation(invitationId);
      // }
      await authContext?.waitForRolesToUpdate();
      if (invite?.channelId) {
        await authContext?.getChannel();
        navigate("../channels/preview");
      } else {
        navigate("../home");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      <LoadingPopup isLoading={loading} loadingText="Fetching detail.." />
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal">{`Find the list below you are invited to.`}</p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col items-center justify-center gap-10">
            <>
              {authContext?.myInvites?.map(item => {
                const channel = channels?.find(obj => obj.id === item.channelId);
                return (
                  <InviteCard
                    invite={item}
                    onSelect={id => {
                      onSelect(id);
                    }}
                    selected={selectedInviteId === item.id}
                    channel={channel}
                  />
                );
              })}
            </>
          </div>
        </div>
      </div>
    </section>
  );
};

type CardProps = {
  invite: MemberInvite;
  onSelect: (inviteId: string) => void;
  selected: boolean;
  channel?: SKChannel;
};

const InviteCard: React.FC<CardProps> = ({ invite, onSelect, selected, channel }) => {
  return (
    <div
      onClick={() => {}}
      className={
        (invite.invitedByUserId === "user@skarvo" ? " border-red-400 " : "border-black ") +
        "w-full border-2 col-span-1 row-span-1 p-4 bg-white  rounded-2xl shadow-sm min-h-[105px]"
      }
    >
      <div className="flex flex-col gap-4 ">
        <div className="mb-5 flex flex-col space-y-[10px] min-w-[290px] min-h-[96px] max-w-[450px] max-h-[150px]">
          {/* {progress > 0 && <progress value={progress} max="100" />} */}
          {channel && channel.backgroundImageUrl && (
            <img
              className="space-y-[10px] min-w-[290px] min-h-[96px] max-w-[450px] max-h-[150px]"
              style={{
                borderColor: "grey",
                borderWidth: "0.05rem",
                borderStyle: "solid",
                margin: "1px",
              }}
              //src="/icons/bannerimg.png"
              src={channel.backgroundImageUrl}
              alt=""
            />
          )}
        </div>
        <div className="mb-5 flex flex-col items-start min-w-[60px] min-h-[60px] max-w-[120px] max-h-[120px]  rounded-lg">
          {/* {progress > 0 && <progress value={progress} max="100" />} */}
          {channel && channel.profileImageUrl && (
            <img
              style={{
                borderColor: "grey",
                borderWidth: "0.05rem",
                borderStyle: "solid",
                margin: "1px",
                borderRadius: "6.375rem",
              }}
              //src="/icons/profileimg.png"
              src={channel.profileImageUrl}
              className="pr-1 pl-1 min-w-[60px] min-h-[60px] max-w-[120px] max-h-[120px]  rounded-lg"
              alt=""
            />
          )}
        </div>
        <div className="flex flex-col items-center justify-center w-full pr-8">
          <span>For:</span>
          <h2 className="text-lg font-semibold">{invite.channelName ? invite.channelName + " Editor" : "Skarvo Operations"}</h2>
          <span>Invited By:</span>
          <p className="text-sm font-semibold text-gray-600">{invite.invitedBy}</p>
        </div>
        <div className="w-full p-4 text-center">
          <Link to="#" onClick={() => onSelect(invite.id)} className="w-[180px] w-button formprimarybutton">
            Get Started
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InviteList;
